// Styled components for ChipInput UI
// This file defines styled layout and UI primitives for the ChipInput component using Stitches.

import { styled } from "@stitches/react";

/**
 * Chip
 * Styled component for an individual chip/tag, with hover and icon styles.
 */
export const Chip = styled("div", {
  backgroundColor: "#DBDBDB",
  padding: "1px 6px 1px 8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  border: "2px solid #DBDBDB",
  borderRadius: "20px",

  svg: {
    cursor: "pointer !important",
  },

  "&:hover": {
    border: "2px solid #0466b4",
    boxShadow: "0 1px 8px 0 rgba(0, 0, 0, .25)",
  },
});

/**
 * ChipInputContainer
 * Container for the chip list and input, with wrapping and spacing.
 */
export const ChipInputContainer = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  padding: "8px !important",
  height: "max-content !important",
  width: "100% !important",
});

/**
 * ChipInputClear
 * Styled input for adding new chips, with no border or background.
 */
export const ChipInputClear = styled("input", {
  border: "none",
  outline: "none",
  backgroundColor: "transparent",
});
